import { render, staticRenderFns } from "./MemberTable.vue?vue&type=template&id=ab5c6902&scoped=true"
import script from "./MemberTable.vue?vue&type=script&lang=ts"
export * from "./MemberTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5c6902",
  null
  
)

export default component.exports